import React from "react";
import testPreferencesIcon from "../../../assets/test-new/testPreferencesIcon.svg";
import "./TopButtons.css";
import { Button } from "react-bootstrap";
import ReactTooltip from 'react-tooltip';

const TestPreferenceButton = ({ hidden, disabled, onClick, variant }) => {
  return (
    <>
      <Button
        className="top-buttons-frame"
        onClick={onClick}
        variant={variant}
        data-tip="Test Preferences"
        data-for="test-preferences-tooltip"
        hidden={hidden}
        disabled={disabled}
      >
        <img
          className="material-symbols"
          alt="Test Preferences"
          src={testPreferencesIcon}
        />
      </Button>

      <ReactTooltip id="test-preferences-tooltip" place="top" effect="solid" />
    </>
  );
};

export default TestPreferenceButton;
